import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PedidoComponent } from './pedido/pedido.component';
import { ProdutoPesquisaComponent } from './produto_pesquisa/produto_pesquisa.component';
import { LoginComponent } from './login/login.component';
import { AdmComponent } from './adm/adm.component';
import { DadosComponent } from './dados/dados.component';
import { AuthGuard } from './guards/auth.guard';
export const ROUTES: Routes = [
    {
        path: ':id', component: DadosComponent, children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'login', component: LoginComponent },
            { path: 'pesquisa', component:  ProdutoPesquisaComponent},
            {  path: 'adm', canLoad: [AuthGuard], loadChildren: './adm/adm.module#AdmModule'} 
        ]
    }
];


// WEBPACK FOOTER //
// ./src/app/app.routes.ts